/* ----------------Base route--------------------*/
export const BASE_ROUTE = '{0}search'; // {0} - Appname - Mail/Calendar/People

/* ----------------Screen routes--------------------*/
export const SUGGESTIONS_ROUTE = '/';
export const RESULTS_ROUTE = '/results/:tabName/:queryString';
export const RESULTS_ROUTE_STRING = '/results/{0}/{1}';

/* ----------------Results route tab names--------------------*/
export const MAIL_TAB = 'mail';
export const PEOPLE_TAB = 'people';
export const EVENTS_TAB = 'events';

/* ----------------Mail results routes--------------------*/
export const MAIL_RESULTS_ROUTE = '/results/mail/:queryString';
export const READING_PANE_ROUTE = '/searchItemId/:itemId';
export const READING_PANE_ROUTE_STRING = '/results/mail/{0}/searchItemId/{1}';
export const COMPOSE_ROUTE = '/searchComposeId/:composeId';
export const COMPOSE_ROUTE_STRING = '/results/mail/{0}/searchItemId/{1}/searchComposeId/{2}';
export const COMPOSE_CARD_ROUTE_STRING =
    '/results/mail/{0}/searchItemId/{1}/searchComposeId/{2}/card/{3}/{4}/front';
export const CARD_ROUTE = '/card/:routeIdType?/:routeId?/:view';
export const CARD_ROUTE_STRING = '/results/mail/{0}/searchItemId/{1}/card/{2}/{3}/front';
export const READING_PANE_ATTACHMENT_ROUTE_STRING =
    '/results/mail/{0}/searchItemId/{1}/attachmentId/{2}';
export const COMPOSE_ATTACHMENT_ROUTE_STRING =
    '/results/mail/{0}/searchItemId/{1}/searchComposeId/{2}/attachmentId/{3}';
export const ATTACHMENT_ROUTE = '/attachmentId/:attachmentId';

/* ----------------People results routes--------------------*/
export const PEOPLE_RESULTS_ROUTE = '/results/people/:queryString';
export const PEOPLE_RESULTS_CARD_ROUTE_STRING = '/results/people/{0}/card/{1}/{2}/front';

/* ----------------Events results routes--------------------*/
export const EVENTS_RESULTS_ROUTE = '/results/events/:queryString';
